import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../../caremap/CareMapState';
import { NoteCreationChooser } from './NoteCreationChooser';
import { AddNoteWithQueryParamDrawer } from './AddNoteWithQueryParamDrawer';

export const QuickAddNote: React.FC<{ useIcon?: boolean, trackingFrom?: string }> = ({ useIcon, trackingFrom }) => {
    const addNoteDrawer = useInstance(AddNoteWithQueryParamDrawer);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const canAdd = careMapState.hasPermissionTo('post-note');

    return canAdd && (
        <NoteCreationChooser
            useIcon={useIcon}
            canAdd={canAdd}
            onTypeIt={() => addNoteDrawer.open({ trackingFrom })}
        />
    );
};
